export default __webpack_public_path__ + "static/media/file.1d160543.svg";